module.exports = __webpack_public_path__ + "img/trading-default.a49c3428.png";